export default __webpack_public_path__ + "static/media/facebook-icon.106db769.svg";